import Page from "../pages/Page";
import "~/globals";
import { shareOnFacebook } from "~/socialFacebook";

export default class News extends Page {

    constructor() {
        super("news", "News");
    }

    private initReadingTime(): void {
        const content = document.getElementById("txtContent");
        if (!content) return;

        const word = content.innerText.split(" ").length;
        const minuti = Math.floor(word / 200);
        const $txtMinuti = $("#txtMinuti");

        if (minuti < 1) {
            $txtMinuti.html("meno di 1 minuto di lettura");
        } else if (minuti === 1) {
            $txtMinuti.html(`~ ${minuti} minuto di lettura`);
        } else {
            $txtMinuti.html(`~ ${minuti} minuti di lettura`);
        }
    }

    private initShareFacebook(): void {
        $(document).on("click", ".btn-facebook", async (e: JQuery.ClickEvent) => {
            e.preventDefault();
            try {
                await shareOnFacebook(window.location.href);
            } catch (error) {
                console.error("Errore condivisione Facebook:", error);
            }
        });
    }

    async pageStart(): Promise<void> {

        this.initReadingTime();
        this.initShareFacebook();

        return Promise.resolve();
    }
}